import { render, staticRenderFns } from "./ItemCardHeader.vue?vue&type=template&id=3b9df2c9&scoped=true&"
import script from "./ItemCardHeader.vue?vue&type=script&lang=js&"
export * from "./ItemCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./ItemCardHeader.vue?vue&type=style&index=0&id=3b9df2c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9df2c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
